import { z } from "zod";

export const getUploadAvatarFormModelSchema = () =>
	z.object({
		avatarFile: z.union([z.instanceof(File).nullable().optional(), z.string()]),
	});

export type UploadAvatarFormModel = z.infer<
	ReturnType<typeof getUploadAvatarFormModelSchema>
>;
